import MUIBox from '@/components/MUI-Components/MUI-Box';
import MUIGrid from '@/components/MUI-Components/MUI-Grid';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import React, {memo} from 'react';
import DisplayImage from '../display-image';
import {colors, fontFamily, fontSize, fontWeight, spacing, transition} from '@/styles/tokens';

// ─── Module-level sx constants (was `.devops-business-content-wrapper` / `.devops-business-card` /
// `.devops-main-img-wrapper` / `.devops-main-img-grid` / `.devops-business-content-wrapper-right` /
// `.devops-buniness-card-subheading` in globals.scss) ──────────────────────────────────────────
const devopsBusinessContentWrapperSx = {
    display: 'flex',
    '@media (max-width: 992px)': {
        height: '780px'
    },
    '@media (max-width: 600px)': {
        height: 'auto'
    },
    '@media (max-width: 430px)': {
        display: 'block'
    }
} as const;

const devopsBusinessCardSx = {
    height: '200px',
    '@media (max-width: 1024px)': {
        height: '220px'
    },
    '@media (max-width: 430px)': {
        height: 'auto'
    }
} as const;

const devopsMainImgWrapperSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
        transform: 'scale(1)',
        transition: transition.slow
    },
    '& img:hover': {
        transform: 'scale(1.1)',
        transition: transition.slow
    },
    '@media (max-width: 1024px)': {
        '& img': {
            display: 'none'
        }
    }
} as const;

const devopsBuninessCardSubheadingSx = {
    fontFamily: fontFamily.body,
    fontSize: fontSize[16],
    fontWeight: fontWeight.regular,
    lineHeight: 1.43, // no exact lineHeightRatio token match
    color: colors.text.primary
} as const;

const devopsMainImgGridSx = {
    '@media (max-width: 768px)': {
        display: 'none'
    }
} as const;

const devopsBusinessContentWrapperRightSx = {
    '@media (max-width: 430px)': {
        textAlign: 'left',
        flexWrap: 'wrap-reverse',
        paddingTop: spacing[16]
    }
} as const;
// ─────────────────────────────────────────────────────────────────────────────────────────────

const DevopsBusiness = (props: any) => {
    const {heading, subheading, BusinessDataLower, BusinessDataUpper, serverImg} = props;

    return (
        <MUIBox>
            <MUIBox className="spectrum-header-wrapper ">
                <MUITypography className="spectrum-heading color-black" component="h3">
                    {heading}
                </MUITypography>
                <MUIBox className="divder-wrapper">
                    <hr className="divider-line" />
                </MUIBox>
                <MUIBox className="sub-heading-box ">
                    <MUITypography className="spectrum-sub-heading color-black">{subheading}</MUITypography>
                </MUIBox>
            </MUIBox>
            <MUIBox sx={devopsBusinessContentWrapperSx} pt={2}>
                <MUIGrid container spacing={3}>
                    {BusinessDataUpper?.map((item: any, index: number) => (
                        <MUIGrid item md={12} key={index} sx={devopsBusinessCardSx}>
                            <MUIBox>
                                <MUIGrid container>
                                    <MUIGrid item md={2} sm={3}>
                                        <DisplayImage src={item?.img} width={50} alt="devops-img" />
                                    </MUIGrid>
                                    <MUIGrid item md={10} sm={9}>
                                        <MUITypography className="devops-buniness-card-heading">{item?.heading}</MUITypography>
                                        <MUITypography sx={devopsBuninessCardSubheadingSx}>{item?.subheading}</MUITypography>
                                    </MUIGrid>
                                </MUIGrid>
                            </MUIBox>
                        </MUIGrid>
                    ))}
                </MUIGrid>
                <MUIGrid container sx={devopsMainImgGridSx}>
                    <MUIBox sx={devopsMainImgWrapperSx}>
                        <DisplayImage src={serverImg} width={450} alt="devops-img" />
                    </MUIBox>
                </MUIGrid>
                <MUIGrid container spacing={3}>
                    {BusinessDataLower?.map((item: any, index: number) => (
                        <MUIGrid item md={12} key={index}>
                            <MUIGrid container textAlign="right" sx={devopsBusinessContentWrapperRightSx}>
                                <MUIGrid item md={10} sm={10}>
                                    <MUITypography className="devops-buniness-card-heading">{item?.heading}</MUITypography>
                                    <MUITypography sx={devopsBuninessCardSubheadingSx}>{item?.subheading}</MUITypography>
                                </MUIGrid>
                                <MUIGrid item md={2} sm={2}>
                                    <DisplayImage src={item?.img} width={50} alt="devops-img" />
                                </MUIGrid>
                            </MUIGrid>
                        </MUIGrid>
                    ))}
                </MUIGrid>
            </MUIBox>
        </MUIBox>
    );
};

export default memo(DevopsBusiness);
